
// Calcul des redevances proportionnelles 
export function calculerRedevanceProportionnelle(data) {
    const { categorie, montantBase, butNonLucratif } = data;
    console.log("calculerRedevanceProportionnelle", { categorie, montantBase, butNonLucratif });
    switch (categorie) {
        case "litteraire":
            return montantBase * (butNonLucratif ? 0.02 : 0.05);
        case "dramatique":
            return montantBase * (butNonLucratif ? 0.04 : 0.10);
        case "musique_occasionnelle":
            return montantBase * (butNonLucratif ? 0.04 : 0.08);
        case "musique_cinema":
            return montantBase * (butNonLucratif ? 0.01 : 0.03);
        case "oeuvre_plastique_vente":
            return montantBase * 0.05;
        case "oeuvre_plastique_expo_vente":
            return montantBase * 0.05;
        case "oeuvre_plastique_expo_sans_vente":
            return montantBase * 0.02;
        case "monument_reproduction":
            return montantBase * 0.10;
        case "monument_exploitation_publique":
            return montantBase * 0.08;
        case "photo_expo_vente":
            return montantBase * 0.05;
        case "photo_expo_gratuite":
            return montantBase * 0.02;
        case "domaine_public_art":
            return montantBase * 0.08;
        case "domaine_public_litterature":
            return montantBase * 0.05;
        case "copie_privee_import":
            return montantBase * 0.05;
        case "copie_privee_locale":
            return montantBase * 0.02;
        case "reproduction_mecanique_protegee":
            return montantBase * 0.10;
        case "reproduction_mecanique_publique":
            return montantBase * 0.05;
        default:
            return 0;
    }
}


// Forfaitaire – Bars, cafés, night-clubs, casinos
export function calculerRedevanceForfaitaire(usager) {
    console.log("usager", usager);
    const { type, zone, capacite = 0, etoiles = 0 } = usager;

    // "café" suit le même barème que "bar" (regroupés dans le commentaire
    // ci-dessus et non distingués dans le tableau A3).
    if (type === "bar" || type === "café") {
        if (!zone) return 0;
        if (capacite <= 30) return zone === "district" ? 14000 : zone === "urbaine" ? 11000 : 5000;
        if (capacite <= 100) return zone === "district" ? 15000 : zone === "urbaine" ? 12000 : 6000;
        return zone === "district" ? 16000 : zone === "urbaine" ? 13000 : 7000;
    }

    // "dancing" et "casino" regroupés avec "night-club" dans le texte légal
    // ("bars, dancings et night-clubs" — dump SQL, table categories, id 3).
    if (type === "night-club" || type === "dancing" || type === "casino") {
        if (!zone) return 0;
        return zone === "district" ? 50000 : zone === "urbaine" ? 30000 : 15000;
    }

    if (type === "restaurant" || type === "salon de thé" || type === "pâtisserie") {
        return capacite <= 10 ? 7500 : 12500;
    }

    if (type === "hotel") {
        if (etoiles === 0) {
            if (capacite < 50) return 10000;
        } else if (etoiles >= 1 && etoiles <= 3) {
            if (capacite < 50) return 20000;
            if (capacite <= 100) return 25000;
            if (capacite <= 200) return 40000;
            return 60000;
        } else if (etoiles === 4) {
            if (capacite < 50) return 25500;
            if (capacite <= 100) return 30000;
            if (capacite <= 200) return 50000;
            return 90000;
        } else if (etoiles === 5) {
            if (capacite < 50) return 30000;
            if (capacite <= 100) return 40000;
            if (capacite <= 200) return 70000;
            return 120000;
        }
    }

    return 0;
}


export function calculerRedevanceForfaitaire_2(usager) {
    console.log("calculerRedevance", usager);
    switch (usager.type) {
        case 'commerce':
            if (usager.sousType === 'A') {
                if ((usager.superficie || 0) < 100) return 1000;
                return 2000;
            } else if (usager.sousType === 'B') return 1500;
            else if (usager.sousType === 'C') return (usager.superficie || 0) < 100 ? 3000 : 3500;
            else if (usager.sousType === 'D') return 2000;
            else if (usager.sousType === 'E') {
                const places = usager.nombrePlaces || 0;
                if (places <= 5) return 1000;
                if (places <= 10) return 2000;
                return 5000;
            }
            break;

        case 'banque':
            if (usager.sousType === 'primaire') return 25000;
            if (usager.sousType === 'secondaire') return 15000;
            return 10000;

        case 'infrastructures_sportives':
            if (usager.sousType.includes('stade') ) {
                 console.log('sousType', usager.sousType);
                if (usager.nombrePlaces == 'moins_10000'   ) return 10000;
                if (usager.nombrePlaces == 'entre_15000_20000') return 15000;
                return 20000;
            }
            if (usager.sousType === 'basket') return 20000;
            if (usager.sousType === 'piscine') return 5000;
            if (usager.sousType === 'complexe') return 10000;
            if (usager.sousType === 'aerobics') return 10000;
            if (usager.sousType === 'pmu') return 50000;
            break;

        case 'vehicule':
            if (usager.sousType === 'vehicules_publicitaires_sonorises') return 2500;
            if (usager.sousType === 'vehicules_transport_commun') {
                const places = usager.nombrePlaces || 0;
                if (usager.diffusion === 'audio') {
                    return places <= 35 ? 1000 : 1500;
                } else {
                    return places <= 35 ? 1200 : 2000;
                }
            }
            break;

        case 'gares':
            const places = usager.nombrePlaces || 0;
            if (usager.sousType === 'bateau') return 30000;
            if (usager.sousType === 'quai') return 50000;
            if (usager.sousType === 'aeroport') {
                return usager.couverture === 'international' ? 100000 : 12500;
            }
            if (usager.sousType === 'aeronef') {
                return usager.couverture === 'international' ? 125000 : 50000;
            }
            if (usager.sousType === 'train') {
                return usager.couverture === 'transnational' ? 100000 : 50000;
            }
            if (usager.diffusion === 'audio') {
                if (places <= 50) return 1500;
                if (places <= 80) return 2000;
                return 3000;
            } else {
                if (places <= 50) return 2000;
                if (places <= 80) return 2500;
                return 3500;
            }

        case 'telephonie':
            if (usager.sousType === 'cybercafe') return 3000;
            if (usager.sousType === 'site_specialise') return 5000000;
            return 1500000;

        case 'radio_television':
            if (usager.sousType === 'tv_internationale') return 20000000;
            if (usager.sousType === 'tv_locale') return 5000000;
            if (usager.sousType === 'radio_nationale') {
                if (usager.zone === 'Bamako') {
                    return usager.radioModel === 'commerciale' ? 25000 : 20000;
                }
                if (usager.zone === 'Urbain') {
                    return usager.radioModel === 'commerciale' ? 15000 : 10000;
                }
                if (usager.zone === 'Rural') {
                    return usager.radioModel === 'commerciale' ? 10000 : 5000;
                }
                return 10000000;}
          
            if (usager.sousType === 'fournisseur_image') return 10000000;
            break;

        case 'activites_temporaires':

            if (usager.sousType === 'rue') return 300000;
            if (usager.sousType === 'foire') return 1000000;
            if (usager.sousType === 'cirque') return 250000;
            return 10000;
    }
    return 0;
}


/**
 * Compte le nombre de redevables par type
 * @param {Object} data - Données des redevables avec structure { data: [], meta: {} }
 * @returns {Object} - Objet avec le nombre par type et le total
 */
export function getRedevableNumberByType(data) {
    if (!data || !data.data || !Array.isArray(data.data)) {
        return {
            types: {},
            total: 0,
            error: "Données invalides"
        };
    }

    const typeCount = {};
    let total = 0;

    data.data.forEach(redevable => {
        const type = redevable.attributes?.category;
        
        if (type) {
            // Normaliser le type (enlever espaces, mettre en minuscules)
            const normalizedType = type.trim().toLowerCase();
            
            if (typeCount[normalizedType]) {
                typeCount[normalizedType]++;
            } else {
                typeCount[normalizedType] = 1;
            }
            total++;
        } else {
            // Compter les types non définis
            if (typeCount['non_défini']) {
                typeCount['non_défini']++;
            } else {
                typeCount['non_défini'] = 1;
            }
            total++;
        }
    });

    return {
        types: typeCount,
        total: total,
        totalFromMeta: data.meta?.pagination?.total || 0,
        error: null
    };
}

/**
 * Obtient les statistiques détaillées par type
 * @param {Object} data - Données des redevables
 * @returns {Object} - Statistiques détaillées
 */
export function getDetailedTypeStatistics(data) {
    const result = getRedevableNumberByType(data);
    
    if (result.error) {
        return result;
    }

    const sortedTypes = Object.entries(result.types)
        .sort((a, b) => b[1] - a[1]) // Tri par nombre décroissant
        .map(([type, count]) => ({
            type: type,
            count: count,
            percentage: ((count / result.total) * 100).toFixed(2)
        }));

    return {
        ...result,
        sortedTypes: sortedTypes,
        mostCommonType: sortedTypes[0] || null,
        leastCommonType: sortedTypes[sortedTypes.length - 1] || null
    };
}


/**
 * Crée la répartition par type de redevance avec émojis et couleurs
 * @param {Object} data - Données des redevables
 * @returns {Array} - Tableau d'objets avec type, count, emoji, couleur
 */
export function getRepartitionParTypeRedevance(data) {
    const stats = getRedevableNumberByType(data);
    
    if (stats.error) {
        return [];
    }

    // Mapping des types avec émojis et couleurs
    const typeMapping = {
        'télévision': { emoji: '📺', color: 'blue', bgColor: 'bg-blue-100', textColor: 'text-blue-800' },
        'radio': { emoji: '📻', color: 'red', bgColor: 'bg-red-100', textColor: 'text-red-800' },
        'radio_television': { emoji: '📻', color: 'purple', bgColor: 'bg-purple-100', textColor: 'text-purple-800' },
        'commerce': { emoji: '🏢', color: 'green', bgColor: 'bg-green-100', textColor: 'text-green-800' },
        'restaurant': { emoji: '🍽️', color: 'orange', bgColor: 'bg-orange-100', textColor: 'text-orange-800' },
        'hôtel': { emoji: '🏨', color: 'indigo', bgColor: 'bg-indigo-100', textColor: 'text-indigo-800' },
        'hotel': { emoji: '🏨', color: 'indigo', bgColor: 'bg-indigo-100', textColor: 'text-indigo-800' },
        'bar': { emoji: '🍺', color: 'yellow', bgColor: 'bg-yellow-100', textColor: 'text-yellow-800' },
        'night-club': { emoji: '🌃', color: 'pink', bgColor: 'bg-pink-100', textColor: 'text-pink-800' },
        'banque': { emoji: '🏦', color: 'emerald', bgColor: 'bg-emerald-100', textColor: 'text-emerald-800' },
        'telephonie': { emoji: '📱', color: 'cyan', bgColor: 'bg-cyan-100', textColor: 'text-cyan-800' },
        'site_specialise': { emoji: '🌐', color: 'teal', bgColor: 'bg-teal-100', textColor: 'text-teal-800' },
        'gares': { emoji: '🚌', color: 'gray', bgColor: 'bg-gray-100', textColor: 'text-gray-800' },
        'infrastructures_sportives': { emoji: '⚽', color: 'lime', bgColor: 'bg-lime-100', textColor: 'text-lime-800' },
        'vehicule': { emoji: '🚗', color: 'amber', bgColor: 'bg-amber-100', textColor: 'text-amber-800' },
        'activité_temporaire': { emoji: '🎪', color: 'rose', bgColor: 'bg-rose-100', textColor: 'text-rose-800' },
        'non_défini': { emoji: '❓', color: 'slate', bgColor: 'bg-slate-100', textColor: 'text-slate-800' }
    };

    // Convertir les stats en format pour l'affichage
    const repartition = Object.entries(stats.types).map(([type, count]) => {
        const mapping = typeMapping[type] || typeMapping['non_défini'];
        
        // Capitaliser le nom du type pour l'affichage
        const displayName = type === 'non_défini' ? 'Non défini' : 
                          type.charAt(0).toUpperCase() + type.slice(1).replace('_', ' ');

        return {
            type: type,
            displayName: displayName,
            count: count,
            percentage: ((count / stats.total) * 100).toFixed(1),
            emoji: mapping.emoji,
            color: mapping.color,
            bgColor: mapping.bgColor,
            textColor: mapping.textColor,
            className: `${mapping.bgColor} ${mapping.textColor} rounded-full px-4 py-2 font-semibold`
        };
    }).sort((a, b) => b.count - a.count); // Trier par nombre décroissant

    return repartition;
}

/**
 * Génère le JSX pour la répartition par type
 * @param {Object} data - Données des redevables
 * @returns {JSX.Element} - Composant JSX prêt à afficher
 */
export function generateRepartitionJSX(data) {
    const repartition = getRepartitionParTypeRedevance(data);
    
    if (repartition.length === 0) {
        return (
            <div className="bg-white p-6 rounded-2xl shadow">
                <h3 className="text-gray-500 mb-4">Répartition par Type de Redevance</h3>
                <p className="text-gray-400">Aucune donnée disponible</p>
            </div>
        );
    }

    return (
        <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="text-gray-500 mb-4">Répartition par Type de Redevance</h3>
            <div className="flex flex-wrap gap-4">
                {repartition.map((item, index) => (
                    <div key={index} className={item.className}>
                        {item.emoji} {item.displayName}: {item.count} ({item.percentage}%)
                    </div>
                ))}
            </div>
        </div>
    );
}


/**
 * Génère les statistiques par type pour l'affichage
 * @param {Object} data - Données des redevables
 * @param {number} previousTotal - Total précédent pour calculer le pourcentage de croissance
 * @returns {Object} - Objet avec les statistiques formatées
 */
export function getStatistiquesParType(data, previousTotal = null) {
    // Obtenir les statistiques de base
    const stats = getRedevableNumberByType(data);

    console.log('stats', stats);
    
    if (stats.error) {
        return {
            total: 0,
            growthPercentage: 0,
            growthColor: 'text-gray-500',
            topTypes: [],
            error: stats.error
        };
    }

    // Calculer le pourcentage de croissance
    let growthPercentage = 0;
    let growthColor = 'text-gray-500';
    
    if (previousTotal !== null && previousTotal > 0) {
        growthPercentage = (((stats.total - previousTotal) / previousTotal) * 100).toFixed(1);
        growthColor = growthPercentage >= 0 ? 'text-green-500' : 'text-red-500';
    }

    // Mapping des types avec émojis
    const typeEmojiMapping = {
        'télévision': '📺',
        'radio': '📻',
        'radio_television': '📻',
        'commerce': '🏪',
        'restaurant': '🍽️',
        'hôtel': '🏨',
        'hotel': '🏨',
        'bar': '🍺',
        'night-club': '🌃',
        'banque': '🏦',
        'telephonie': '📱',
        'site_specialise': '🌐',
        'gares': '🚌',
        'infrastructures_sportives': '⚽',
        'vehicule': '🚗',
        'couture': '👗',
        'appartement': '🏢',
        'activité_temporaire': '🎪',
        'non_défini': '❓'
    };

    // Obtenir les 3 types les plus nombreux
    const topTypes = Object.entries(stats.types)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3)
        .map(([type, count]) => {
            const emoji = typeEmojiMapping[type] || '📊';
            const displayName = type === 'non_défini' ? 'Non défini' : 
                              type.charAt(0).toUpperCase() + type.slice(1).replace('_', ' ');
            
            return {
                type: type,
                displayName: displayName,
                count: count,
                emoji: emoji,
                percentage: ((count / stats.total) * 100).toFixed(1)
            };
        });

    return {
        total: stats.total,
        totalFromMeta: stats.totalFromMeta,
        growthPercentage: growthPercentage,
        growthColor: growthColor,
        topTypes: topTypes,
        allTypes: stats.types,
        error: null
    };
}
/**
 * Génère le JSX pour les statistiques par type
 * @param {Object} data - Données des redevables
 * @param {number} previousTotal - Total précédent pour calculer la croissance
 * @returns {JSX.Element} - Composant JSX prêt à afficher
 */
export function generateStatistiquesParTypeJSX(data, previousTotal = null) {
    const stats = getStatistiquesParType(data, previousTotal);
    
    if (stats.error) {
        return (
            <div className="bg-white p-6 rounded-2xl shadow">
                <h3 className="text-gray-500 mb-2">Statistiques par Type</h3>
                <p className="text-gray-400">Erreur lors du chargement des données</p>
            </div>
        );
    }

    const growthSign = stats.growthPercentage >= 0 ? '+' : '';

    return (
        <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="text-gray-500 mb-2">Statistiques par Type</h3>
            <p className="text-2xl font-bold">
                {stats.total.toLocaleString()} 
                {stats.growthPercentage !== 0 && (
                    <span className={`${stats.growthColor} text-sm ml-2`}>
                        {growthSign}{stats.growthPercentage}%
                    </span>
                )}
            </p>
            <div className="mt-4">
                <ul className="space-y-2">
                    {stats.topTypes.map((item, index) => (
                        <li key={index} className="flex justify-between">
                            <span>{item.emoji} {item.displayName}</span>
                            <span className="font-bold">{item.count.toLocaleString()}</span>
                        </li>
                    ))}
                </ul>
                {stats.topTypes.length === 0 && (
                    <p className="text-gray-400 text-sm">Aucune donnée disponible</p>
                )}
            </div>
        </div>
    );
}